import React, { Component } from 'react';
import axios from 'axios';
import format from 'number-format.js';
import './Map.css';
import './leaflet.wmslegend.js';
import './BetterWMS.js';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.min.js';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import 'leaflet-easyprint/dist/bundle.js';
//import 'leaflet-easyPrintDavi/src/index.js';
import { getFeatureInfo } from './GetFeatureInfo';
import { getWMSLegend } from './LeafletWMSLegend';
import { getLegendLeaflet, format_grades, _TIPO_LEGEND_DEFAULT, _TIPO_LEGEND_NATURAL_BREAK, _TIPO_LEGEND_NATURAL_BREAK_PORTOS } from './LegendLeaflet';
import { jenks } from './Jenks';
import PropTypes from 'prop-types';

const is_development = false;

const _CORES_TIPO_MAPA_1 = [
  'FFFF00',
  'FF5500',
  '38A800',
  '005CE6'
];

const _CORES_TIPO_MAPA_2 = [
  'FF5500',
  '38A800',
  '005CE6'
];

const _CORES_PRODUCAO_NATURAL_BREAK = [
  'DCF5E9',
  'A7CFB4',
  '76A882',
  '4A8758',
  '226633',
];

const _CORES_EXPORTACAO_NATURAL_BREAK = [
  'FFFFD4',
  'FED98E',
  'FE9929',
  'CC4C02'
];

const _CORES_PORTOS = [
  'lightblue',
  'blue',
  'darkblue',
  'cadetblue',
];

const _CORES_LEGEND_PORTOS = [
  '93DAFE',
  '51A8DB',
  '2A65A0',
  '4A6977',
];




/*
const _CORES_LEGEND_PORTOS = [
  'C849B4',
  '5A3869',
  '4FA3D5',
  '496876',
];
*/

const _rest_base = is_development ? 'https://mapas.cnpm.embrapa.br/rest-services/macrologistica_services_homologacao/' : 'https://mapas.cnpm.embrapa.br/rest-services/macrologistica_services/';

const _WMS_URL   = is_development ? 'https://mapas.cnpm.embrapa.br/geoserver_homologacao/macrologistica/wms' : 'https://mapas.cnpm.embrapa.br/geoserver/macrologistica/wms';

const _URL_REST_PRODUCAO_JENKS = _rest_base + 'lista-producao-jenks'; 
const _URL_REST_EXPORTACAO_JENKS = _rest_base + 'lista-exportacao-jenks';
const _URL_REST_PORTOS_JENKS = _rest_base + 'lista-portos-jenks';
const _URL_PORTOS_PONTOS = _rest_base + 'lista-portos-pontos'; 

const _URL_ZOOM_ESTADO = _rest_base + 'lista-zoom-estados';
const _URL_ZOOM_REGIAO = _rest_base + 'lista-zoom-regioes';
const _URL_ZOOM_BACIA  = _rest_base + 'lista-zoom-bacias';

const _TIPO_MAPA_PRODUCAO1 = '1';
const _TIPO_MAPA_PRODUCAO2 = '2';
const _TIPO_MAPA_PRODUCAO_JENKS = '3';
const _TIPO_MAPA_EXPORTACAO_JENKS = '4';
const _TIPO_MAPA_GERAL = '5';
const _TIPO_MAPA_BACIAS = '6';
const _TIPO_MAPA_COMPARATIVO_G75 = '7';

//const _VARIAVEL_AREA = 'area_plantada';
const _VARIAVEL_QUANTIDADE = 'qtde_produzida';

const _STYLE1 = 'quartel';
const _STYLE2 = 'g75_quartel';
const _STYLE3 = 'quartel_natural_breaks_area';
const _STYLE4 = 'quartel_natural_breaks_qttde_produzida';
const _STYLE5 = 'exportacao_ton_liquid';

const _LAYER_PRODUCAO = is_development ? 'v_producao' : 'v_producao';
const _LAYER_EXPORTACAO = 'exportacao';
const _LAYER_COMPARATIVO_G75 = 'sv_quartel_ano';

const _NUMERO_CLASSES4 = 4;
const _NUMERO_CLASSES5 = 5;

export const generateURLGetLegend = (url, layerName) => {

  const params = {
    request: 'GetLegendGraphic',
    version: '1.1.0',
    format: 'image/png',
    width: 20,
    height: 20,
    layer: layerName,
    legend_options: 'forceLabels:on'
  };

  return url + L.Util.getParamString(params, url, true);

}

const createMapOSM = () => {
  const osmUrl = 'https://{s}.tile.osm.org/{z}/{x}/{y}.png';
  const osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
  return new L.TileLayer(osmUrl, { attribution: osmAttrib });
}

const createLayer = (layer, cql_filter, styles, env, viewparams) => {

  let options = {
    layers: layer,
    format: 'image/png', 
    EPSG: '4326',
    tiled: true,
    //tileSize: L.point(3000,3000),
    transparent: true, 
    attribution: '',
    opacity: 1
  }

  // cria os seguintes atributos apenas se forem especificados nos parâmetros
  if (cql_filter) {
    options.cql_filter = cql_filter;
  }
  if(viewparams){
    options.viewparams = viewparams;
  }
  options.styles = styles ? styles : '';
  options.env = env ? env : undefined;

  return new L.tileLayer.wms(_WMS_URL, options);

}

// formata numeros com pontos
const format_number_with_points = n => {
  // se não for um numero retorna sem formatar
  if( isNaN(n) ){
      return n;
  }

  let formated = n === 0 ? '0' : format("###,###.#", n);
  var find = ',';
  var re = new RegExp(find, 'g');
  return formated.replace(re, '.');
} 

const createMap = () => {
  const map = L.map('map', {
    center: [-16, -54],
    zoomSnap: 0.1,
    zoom: 4.3,
    attributionControl: false
  });

  getFeatureInfo(map, ['estado'], (results) => {
    // transforma os dados recebidos no getFeatureInfo
    
    results.map(r => {
      const layerName = results[0].layerName;
      const props = Object.entries(results[0].features.properties); 
      // navega pelas propriedades recebidas
      props.map(p => {
        let attr = p[0];
        let value = undefined;
        // não formata o valor se for ano inicial ou final em sv_quartel_ano
        if( layerName === 'sv_quartel_ano' && (attr === 'ano_inicial' || attr === 'ano_final')){
           value = p[1];
        } else {
          value = format_number_with_points(p[1]);
        }
        results[0].features.properties[attr] = value;
        return p;
      });
      return r;
    });

    return results;


  }); // não apresenta o estado na consulta getfeatureinfo

  return map;
}

const mountQueryClause = (params) => {
  let cql_filter = "";

  // producao
  cql_filter += params.ano ? "ano = " + params.ano + " and " : "";
  cql_filter += params.produto ? "produto = '" + params.produto + "' and " : "";
  cql_filter += params.regiao ? "regiao = '" + params.regiao + "' and " : "";
  cql_filter += params.bacia ? "bacia = '" + params.bacia + "' and " : "";
  cql_filter += params.uf ? "uf = '" + params.uf + "' and " : "";
  cql_filter += params.nivel ? "nivel = '" + params.nivel + "' and " : "";
  cql_filter += params.territorio ? "territorio = '" + params.territorio + "' and " : "";
  cql_filter += params.variavel ? "variavel = '" + params.variavel + "' and " : "";
  cql_filter += params.ano_inicial ? "ano_inicial = '" + params.ano_inicial + "' and " : "";
  cql_filter += params.ano_final ? "ano_final = '" + params.ano_final + "' and " : "";

  // remove o ultimo and
  cql_filter = cql_filter.substring(0, cql_filter.lastIndexOf('and'));

  return cql_filter;
}

const mountViewParams = (params) => {
  let q_string = "";
  Object.keys(params).forEach((key,index) => {
    q_string += key + ":" + params[key] + ";";
  });

  // coloca \\ em todas as virgulas para que o sql_view consiga compilar a q_string
  q_string = q_string.replace(/,/g, "\\,");
  return q_string;
}

const mountQueryString = (params) => {
  let q_string = "";

  // producao
  q_string += params.ano ? "ano=" + params.ano + "&" : "";
  q_string += params.produto ? "produto=" + params.produto + "&" : "";
  q_string += params.regiao ? "regiao=" + params.regiao + "&" : "";
  q_string += params.bacia ? "bacia=" + params.bacia + "&" : "";
  q_string += params.uf ? "uf=" + params.uf + "&" : "";
  q_string += params.nivel ? "nivel=" + params.nivel + "&" : "";
  q_string += params.territorio ? "territorio=" + params.territorio + "&" : "";
  q_string += params.variavel ? "variavel=" + params.variavel + "&" : "";
  q_string += params.ano_inicial ? "ano_inicial=" + params.ano_inicial + "&" : "";
  q_string += params.ano_final ? "ano_final=" + params.ano_final + "&" : "";

  // remove o ultimo and
  q_string = q_string.substring(0, q_string.lastIndexOf('&'));

  return q_string;
}

// cria a string de env para enviar para o sld
const mount_envs = (array_jenks, cores) => {
  let env = '';
  
  for (let i = 0; i < array_jenks.length - 1; i++) {
    env += 'min' + (i + 1) + ':' + array_jenks[i] + ';';
    env += 'max' + (i + 1) + ':' + array_jenks[i + 1] + ';';
    env += 'cor' + (i + 1) + ':' + cores[i] + ';';
  }
  return env;
}

const remove_ano_from = (query_string, query_clause) => {
  let str_ano = query_string.substring(query_string.indexOf('ano'), 14);
  let new_query_string = query_string.replace(str_ano, '');

  str_ano = query_clause.substring(query_string.indexOf('ano'), 9);
  let new_query_clause = query_clause.replace(str_ano, '');

  return { new_query_string, new_query_clause };
}


const dispach_jenks = (query_string, url, num_classes, cores, func) => {

  const url_jenks = url + "?" + query_string;
  axios.get(url_jenks)
    .then((response) => {
      console.log(response);
      // cria um array simples com o range recebido
      let array_jenks = [];
      response.data.map(d => {
        array_jenks.push(d.valor);
        return d;
      });

      // verifica se num_classes é menor que tamanho de array_jenks
      // se for duplica ou triplica array_jenks até que ele seja maior
      if( num_classes > array_jenks.length ){
        array_jenks = [...array_jenks, ...array_jenks, ...array_jenks];
      }

      let values = jenks(array_jenks, num_classes);
      values = values.sort((a, b) => a - b);
      const env = mount_envs(values, cores);

      func(values, env);

    })
    .catch(error => console.error("Erro ao tentar ler o conjunto de dados para o jenks ... ", error.message));

}

const createLayerPortos = (map, values_jenks, clause) => {
  // requisita o servico que devolve os pontos dos portos
  let url = _URL_PORTOS_PONTOS + "?" + clause;
  axios.get(url)
    .then((response) => {
      response.data.map(d => {
        const coord = JSON.parse(d.coord);
        const x = coord.coordinates[0][0];
        const y = coord.coordinates[0][1];
        let str_values = '';

        // formata os numeros grandes
        const ton_liquido = format_grades([d.ton_liquido])[0];
        const vl_fob = format_grades([d.vl_fob])[0];

        str_values += 'Nome do Porto : ' + d.nome_porto + '<br>';
        str_values += 'Co Porto : ' + d.co_porto + '<br>';
        str_values += 'Produto : ' + d.produto + '<br>';
        str_values += 'Toneladas-Liquido : ' + ton_liquido + '<br>';
        str_values += 'Vl Fob : ' + vl_fob;

        // enquadra a marca no range do jenks
        let color = undefined;
        for (let index = 0; index < values_jenks.length - 1; index++) {
          // se estiver no penultimo elemento do jenks
          if (index < values_jenks.length - 2) {
            if (d.ton_liquido === values_jenks[index] && values_jenks[index] === values_jenks[index + 1]) {
              color = _CORES_PORTOS[index];
            } else {
              color = d.ton_liquido >= values_jenks[index] && d.ton_liquido < values_jenks[index + 1] ? _CORES_PORTOS[index] : undefined;
            }
            if (color) break;
          } else {
            if (d.ton_liquido === values_jenks[index] && values_jenks[index] === values_jenks[index + 1]) {
              color = _CORES_PORTOS[index];
            } else {
              color = d.ton_liquido >= values_jenks[index] && d.ton_liquido <= values_jenks[index + 1] ? _CORES_PORTOS[index] : undefined;
            }
            if (color) break;
          }
        }

        L.marker([y, x], { icon: L.AwesomeMarkers.icon({ icon: 'anchor', markerColor: color, prefix: 'fa', iconColor: 'white' }) }).addTo(map).bindPopup(str_values);
        return d;
      });
    })
    .catch(error => console.error("Erro ao tentar ler o conjunto de dados para o jenks ... ", error.message));
}

// processa um BOX(287134.2743 7478110.734,287758.0409 7478675.6397) e o transforma em um array para ser usado no fitToBounds
const process_extent_from_bbox = (extent) => {
  let s_extent = extent;
  s_extent = s_extent.substr(4, s_extent.length);
  s_extent = s_extent.substr(0, s_extent.indexOf(")"));
  s_extent = s_extent.replace(",", " ");
  const a_extent = s_extent.split(" ");
  return [[a_extent[1], a_extent[0]], [a_extent[3], a_extent[2]]];
}

const zoomToRegiao_Estado = (map, nivel, territorio) => {
  // requisita o servico que devolve os pontos dos portos
  let url = nivel === 'UF' ? _URL_ZOOM_ESTADO + "?uf=" + territorio : _URL_ZOOM_REGIAO + "?regiao=" + territorio;
  axios.get(url)
    .then((response) => {
      let s_extent = response.data[0].extent;
      map.fitBounds(process_extent_from_bbox(s_extent));
    })
    .catch(error => console.error("Erro ao tentar ler a lista de zooms das regioes e estados ... ", error.message));
}

const zoomToBacia = (map, id_bacia) => {
  let url = _URL_ZOOM_BACIA + "?id_bacia=" + id_bacia;
  axios.get(url)
    .then((response) => {
      let s_extent = response.data[0].extent;
      map.fitBounds(process_extent_from_bbox(s_extent));
    })
    .catch(error => console.error("Erro ao tentar ler a lista de zooms das bacias ... ", error.message));
}

class Map extends Component {

  componentDidMount() {

    let map = createMap();
    map.addLayer(createMapOSM());
    
    L.easyPrint({
      title: 'Imprimir Mapa',
      position: 'topleft',
      exportOnly: false, // exporta para png
      hideControlContainer: false,
      hideClasses: ['leaflet-control-easyPrint','leaflet-control-zoom'], // nao imprime o proprio controle de impressao e o controle de zoom
      sizeModes: ['A4Portrait', 'A4Landscape']
    }).addTo(map);

    if (this.props.params.tipo_mapa === _TIPO_MAPA_BACIAS) {

      // da o zoom na bacia 
      zoomToBacia(map, this.props.params.id_bacia);

      // envia o id recebido com o mapa 6 - bacias para o env, para selecionar uma bacia especifica no estilo sld
      const env = this.props.params.id_bacia ? 'evidencia:' + this.props.params.id_bacia : undefined;
      map.addLayer(createLayer('bacia'));
      map.addLayer(createLayer('rodovia', undefined, "rodovia_por_bacia", env));
      map.addLayer(createLayer('ferrovia', undefined, "ferrovia_por_bacia", env));
      map.addLayer(createLayer('hidrovia', undefined, "hidrovia_por_bacia", env));
      map.addLayer(createLayer('porto', undefined, "porto_por_bacia", env));
      map.addControl(getWMSLegend(map));

      return undefined;
    }

    if (this.props.params.tipo_mapa === _TIPO_MAPA_GERAL) {
      map.addLayer(createLayer('rodovia'));
      map.addLayer(createLayer('ferrovia'));
      map.addLayer(createLayer('hidrovia'));
      map.addLayer(createLayer('porto'));
      map.addControl(getWMSLegend(map));
      return undefined;
    }

    let cql_filter = mountQueryClause(this.props.params);
    let filter_params = mountQueryString(this.props.params);

    let styles = undefined;
    if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO1) {
      styles = _STYLE1;
    } else if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO2) {
      styles = _STYLE2;
    } else if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO_JENKS) {
      if (this.props.params.variavel === 'area_plantada') {
        styles = _STYLE3;
      }
      if (this.props.params.variavel === 'area_colhida') {
        styles = 'quartel_natural_breaks_area_colhida';
      }
      if (this.props.params.variavel === _VARIAVEL_QUANTIDADE) {
        styles = _STYLE4;
      }
    }


    // só adiciona a layer de producao se houver filtros - essa layer possui mais de 500.000 registros
    if (cql_filter && cql_filter.length > 0) {

      // da o zoom na bacia se for espeficiado nivel == 'bacia' e o id_bacia
      if (this.props.params.nivel && this.props.params.nivel.toUpperCase() === 'BACIA') {
        zoomToBacia(map, this.props.params.id_bacia)
      }

      // mapa comparativo G75
      if (this.props.params.tipo_mapa === _TIPO_MAPA_COMPARATIVO_G75) {
        const params = mountViewParams({
            'PRODUTO' : "'" + this.props.params.produto + "'",
            'TERRITORIO' : "'" + this.props.params.territorio + "'",
            'NIVEL' : "'" + this.props.params.nivel + "'",
            'VARIAVEL' : "'" + this.props.params.variavel + "'",
            'ANO_INICIAL' : this.props.params.ano_inicial,
            'ANO_FINAL' : this.props.params.ano_final,
        });
        
        map.addLayer(createLayer(_LAYER_COMPARATIVO_G75, null, null, null, params));
        map.addLayer(createLayer('estado'));
        map.addControl(getWMSLegend(map, {}, ['estado']));

        zoomToRegiao_Estado(map, this.props.params.nivel, this.props.params.territorio);
      }


      // mapas de exportação e portos
      if (this.props.params.tipo_mapa === _TIPO_MAPA_EXPORTACAO_JENKS) {

        dispach_jenks(filter_params, _URL_REST_EXPORTACAO_JENKS, _NUMERO_CLASSES4, _CORES_EXPORTACAO_NATURAL_BREAK, (values_jenks, env) => {
          map.addLayer(createLayer(_LAYER_EXPORTACAO, cql_filter, _STYLE5, env));
          map.addControl(getLegendLeaflet(values_jenks, _TIPO_LEGEND_NATURAL_BREAK, _CORES_EXPORTACAO_NATURAL_BREAK, "Valor em Toneladas"));

          // pega os valores dos portos para o jenks
          let p = remove_ano_from(cql_filter, filter_params);
          dispach_jenks(p.new_query_clause.trim(), _URL_REST_PORTOS_JENKS, _NUMERO_CLASSES4, _CORES_EXPORTACAO_NATURAL_BREAK, (values_jenks, env) => {
            // cria a layer dos portos e adiciona no mapa
            createLayerPortos(map, values_jenks, p.new_query_clause);
            // adiciona a layer base de estados
            map.addLayer(createLayer('estado'));
            map.addControl(getLegendLeaflet(values_jenks, _TIPO_LEGEND_NATURAL_BREAK_PORTOS, _CORES_LEGEND_PORTOS, "Valor em Toneladas"));
          });

        });

      } else if(this.props.params.tipo_mapa !== _TIPO_MAPA_COMPARATIVO_G75){

        // mapas de produção 1, 2 e 3

        // aplica o zoom com base no nivel (REGIAO ou UF) e territorio (conteúdo da UF ou REGIAO)
        zoomToRegiao_Estado(map, this.props.params.nivel, this.props.params.territorio);

        //const titulo_legend = this.props.params.variavel = _VARIAVEL_AREA ? "Produção - Área" : "Produção - Quantidade Produzida"
        const titulo_legend = ""; // mapa do Jenks sem titulo na legenda
        if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO_JENKS) {
          dispach_jenks(filter_params, _URL_REST_PRODUCAO_JENKS, _NUMERO_CLASSES5, _CORES_PRODUCAO_NATURAL_BREAK, (values_jenks, env) => {
            map.addLayer(createLayer(_LAYER_PRODUCAO, cql_filter, styles, env));
            // adiciona a layer base de estados
            map.addLayer(createLayer('estado'));
            map.addControl(getLegendLeaflet(values_jenks, _TIPO_LEGEND_NATURAL_BREAK, _CORES_PRODUCAO_NATURAL_BREAK, titulo_legend));
          });
        } else {
          const titulo_legend = "Quartel";
          map.addLayer(createLayer(_LAYER_PRODUCAO, cql_filter, styles));
          // adiciona a layer base de estados
          map.addLayer(createLayer('estado'));
          if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO1) {
            map.addControl(getLegendLeaflet(['Q1', 'Q2', 'Q3', 'Q4'], _TIPO_LEGEND_DEFAULT, _CORES_TIPO_MAPA_1, titulo_legend));
          }
          if (this.props.params.tipo_mapa === _TIPO_MAPA_PRODUCAO2) {
            map.addControl(getLegendLeaflet(['Q2', 'Q3', 'Q4'], _TIPO_LEGEND_DEFAULT, _CORES_TIPO_MAPA_2, titulo_legend));
          }

        }

      }

    }

  }

  render() {
    return (
      <div id='map'>
      </div>
    );
  }
}

export default Map;

Map.propTypes = {
  params: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/Map.js